import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import BidPackageCreateUpdateComponent from '../../components/bid-packages/BidPackageCreateUpdateComponent';
import UpdateBidPackageReasonModal from '../../components/bid-packages/UpdateBidPackageReasonModal';
import { RootState } from '../../modules';
import { BidPackage, updateBidPackageAsync } from '../../modules/bid-packages';
import {
  getBidPackageFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';

interface BidPackageUpdateContainerProps {
  enterpriseId: string;
  projectId: string;
  bidPackageId: string;
}

function BidPackageUpdateContainer({
  match,
  history,
}: RouteComponentProps<BidPackageUpdateContainerProps>) {
  const { enterpriseId, projectId, bidPackageId } = match.params;
  const [uploadProps, setUploadProps] = useState<any>();
  const [visible1, setVisible1] = useState(false);
  const [bidPackageData, setBidPackageData] = useState<any>();
  const bidPackage = useSelector(
    (state: RootState) => state.bidPackages.bidPackage.data,
  );

  // const [gongjongs, setGongjongs] = useState<Tag[]>();
  // const [materialVendorTypes, setMaterialVendorTypes] = useState<Tag[]>();
  useEffect(() => {
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getBidPackageFileAPIPath(enterpriseId, projectId),
        ),
      );
    })();
    // (async () => {
    //   setGongjongs(await getEnterpriseTags('gongjong'));
    // })();
    // (async () => {
    //   setMaterialVendorTypes(await getEnterpriseTags('materialVendorType'));
    // })();
  }, [enterpriseId, projectId]);

  const dispatch = useDispatch();
  const onFinish = (_bidPackage: BidPackage) => {
    const bidPackageObj = {
      ..._bidPackage,
      startDate: moment(_bidPackage.startDate).format('YYYY-MM-DD'),
      endDate: moment(_bidPackage.endDate).format('YYYY-MM-DD'),
      bidDueDateTime: moment(_bidPackage.bidDueDateTime).format(
        'YYYY-MM-DD HH:mm',
      ),
      enterpriseId,
      projectId,
      id: +bidPackageId,
      isChanged: false,
    };

    if (_bidPackage.jobWalkDateTime !== null)
      bidPackageObj.jobWalkDateTime = moment(
        _bidPackage.jobWalkDateTime,
      ).format('YYYY-MM-DD HH:mm');

    for (const _file of bidPackageObj.attachedFiles) {
      if ('response' in _file) {
        _file.path = _file.response.path;
        _file.mimeType = _file.response.mimeType;
      }
    }

    if (bidPackage?.isPublished) {
      setBidPackageData(bidPackageObj);
      setVisible1(true);
      return;
    }

    dispatch(
      updateBidPackageAsync.request({
        enterpriseId,
        projectId,
        bidPackage: bidPackageObj,
      }),
    );
    history.goBack();
  };
  const onCancel = () => {
    history.goBack();
  };

  const onOk = (formData: any) => {
    dispatch(
      updateBidPackageAsync.request({
        enterpriseId,
        projectId,
        bidPackage: {
          ...bidPackageData,
          ...formData,
        },
      }),
    );
    history.goBack();
    setVisible1(false);
  };

  const onCancel2 = () => {
    setVisible1(false);
  };

  return (
    <>
      {bidPackage && uploadProps && (
        <BidPackageCreateUpdateComponent
          enterpriseId={enterpriseId}
          projectId={projectId}
          bidPackage={bidPackage}
          uploadProps={uploadProps}
          onFinish={onFinish}
          onCancel={onCancel}
        />
      )}
      {visible1 && (
        <UpdateBidPackageReasonModal
          onOk={onOk}
          onCancel={onCancel2}
          visible1={visible1}
        />
      )}
    </>
  );
}

export default BidPackageUpdateContainer;
